// ═══ '오토덱스 전체 기능' 둘러보기 줄 (simplify §7·§11·§13) — 맨 위 알림 줄 자리(App.js TestServerBanner)에 그린다 ═══
// 줄 = 버튼 하나(키보드로도 열림): 진한 남색 바탕 + 가운데 정렬 "둘러보는 중" 바로 뒤 작은 ›, 한 줄 — 길면 글자만 … 로 줄고 › 는
// 늘 보인다(Jin 11/05). 바탕은 남색 ↔ 12% 밝은 남색으로 천천히 숨쉬듯(누를 수 있다는 표시, 1.6s 왕복) — 동작 줄이기 설정이면 멈춤.
// 높이 고정(PREVIEW_STRIP_H)
// — App 이 --test-banner-h 로 100vh 셸을 그만큼 줄인다. 줄 안엔 다른 버튼을 두지 않는다(Jin 11/05 §13).
// 누르면 팝업(SheetFrame — 줄 밖 형제라 nowrap·흰 글자를 물려받지 않음):
//   (대표 — canOfferMalso) 설명 malsoModeSheetToFullBody (되돌아오는 법은 [계속 쓰기] 뒤 안내에서만 — Jin 11/05)
//   [말소 화면으로 돌아가기](보조) = 기기 둘러보기 해제 → /main/m/home (서버 호출 없음)
//   (대표) [계속 쓰기](주) → 되돌리는 법 안내 1개(§14: 제목 malsoModeKeepNoticeTitle · 본문 malsoModeKeepNoticeWeb = 전체 기능
//     화면 위쪽 [모드 변경] → '말소대행 신청 화면') → [확인] 이면 switchToFull(서버 PUT) — 둘러보기는 applyMalsoMode 가 지운다.
//     안내를 바깥 탭·Esc·✕ 로 닫으면 적용 안 함(둘러보기 그대로).
//   [닫기]. 직원은 설명 없이 돌아가기 + 닫기. 전환 실패 문구는 안내 안(App 수준엔 토스트가 없다). props: { user }
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { T } from '../../theme';
import { useT } from '../../../i18n/I18nProvider';
import { SheetFrame } from '../../simple/parts/ConfirmSheet';
import { errSt, btnNavy, btnPlain, btnDisabled } from '../../simple/screens/request/bits';
import { canOfferMalso, setMalsoPreview } from '../../simple/screenMode';
import { switchToFull } from '../moreActions';
import { MALSO_HOME } from '../routes';

export var PREVIEW_STRIP_H = 40;

var strip = { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4, width: '100%', height: PREVIEW_STRIP_H,
  boxSizing: 'border-box', padding: '0 16px', border: 0, background: T.navy, color: T.card, fontSize: 13, fontWeight: 600,
  whiteSpace: 'nowrap', cursor: 'pointer', fontFamily: 'inherit', textAlign: 'center' };
// 숨쉬기 — keyframes 는 컴포넌트 안 <style> 한 번(EvalScreen v2evalspin 관례). 밝은 남색 = 테마 토큰 color-mix(hex 리터럴 금지).
// 인라인 animation 을 동작 줄이기 미디어에서 !important 로 끈다.
var PULSE = 'malsoPreviewPulse';
var PULSE_CSS = '@keyframes ' + PULSE + '{from{background-color:' + T.navy + '}to{background-color:color-mix(in srgb,' + T.navy + ' 88%,' + T.card + ')}}'
  + '@media (prefers-reduced-motion: reduce){.malso-preview-strip{animation:none!important}}';
var pulse = { animationName: PULSE, animationDuration: '1.6s', animationTimingFunction: 'ease-in-out',
  animationIterationCount: 'infinite', animationDirection: 'alternate' };
var text = { flex: '0 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' };   // 줄어들기만(늘지 않음) — › 가 바로 뒤에 붙는다
var chevron = { flex: 'none', fontSize: 16, lineHeight: 1 };
var sub = { margin: 0, fontSize: 12.5, color: T.muted, lineHeight: 1.6 };
var full = { width: '100%' };
var closeBtn = { border: 0, background: 'none', padding: '8px 0 0', color: T.muted, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' };

function MalsoPreviewBar(props) {
  var t = useT();
  var navigate = useNavigate();
  var st = useState(''); var sheet = st[0], setSheet = st[1];   // '' | 'menu' | 'notice'
  var se = useState(''); var err = se[0], setErr = se[1];
  var sb = useState(false); var busy = sb[0], setBusy = sb[1];
  var owner = canOfferMalso(props.user);
  var close = function () { setSheet(''); setErr(''); };
  var back = function () {
    setSheet('');
    setMalsoPreview(props.user, false);   // 저장 → 셸 재판정(말소 셸) → 이동
    navigate(MALSO_HOME);
  };
  var apply = function () {
    if (busy) return;
    setErr('');
    setBusy(true);
    // 성공이면 둘러보기가 풀려 이 줄이 사라진다(상태 갱신 없음). 실패면 팝업 안 문구 + 둘러보기 유지.
    switchToFull(navigate, function (msg) { setErr(msg); }, t).then(function (ok) { if (!ok) setBusy(false); });
  };
  return (<React.Fragment>
    <button type="button" className="malso-preview-strip" style={Object.assign({}, strip, pulse)} data-testid="malso-preview-bar" aria-haspopup="dialog" aria-expanded={!!sheet}
      onClick={function () { setSheet('menu'); }}>
      <span style={text}>{t('malsoModePreviewBar')}</span>
      <span style={chevron} aria-hidden="true">›</span>
    </button>
    {/* keyframes 는 줄 뒤 — 맨 위 첫 요소는 줄 그대로 */}
    <style>{PULSE_CSS}</style>
    <SheetFrame open={sheet === 'menu'} title={t('malsoModePreviewBar')} onClose={close} closeLabel={t('actionClose')}>
      {owner ? <p style={sub}>{t('malsoModeSheetToFullBody')}</p> : null}
      <button type="button" style={Object.assign({}, btnPlain, full)} data-testid="malso-preview-back" onClick={back}>
        {t('malsoModePreviewBack')}</button>
      {owner ? (<button type="button" style={Object.assign({}, btnNavy, full)} data-testid="malso-preview-keep"
        onClick={function () { setErr(''); setSheet('notice'); }}>{t('malsoModePreviewKeep')}</button>) : null}
      <button type="button" style={closeBtn} data-testid="malso-preview-close" onClick={close}>{t('actionClose')}</button>
    </SheetFrame>
    <SheetFrame open={sheet === 'notice'} title={t('malsoModeKeepNoticeTitle')} onClose={busy ? null : close} closeLabel={t('actionClose')}>
      <p style={sub} data-testid="malso-keep-notice">{t('malsoModeKeepNoticeWeb')}</p>
      {err ? <div style={errSt} role="alert" data-testid="malso-preview-err">{err}</div> : null}
      <button type="button" style={Object.assign({}, btnNavy, full, busy ? btnDisabled : null)} disabled={busy}
        data-testid="malso-keep-confirm" onClick={apply}>{t('actionConfirm')}</button>
    </SheetFrame>
  </React.Fragment>);
}

export default MalsoPreviewBar;
